import React, { useEffect, useState } from "react";

export default function SyntariLanding() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <div className="min-h-screen bg-[#0a0f1f] text-white flex flex-col">
      {/* MAIN CONTENT */}
      <div className="flex-1 flex flex-col items-center justify-center text-center px-4 sm:px-6 lg:px-8">
        {/* TITLE */}
        <h1 
          className={`text-8xl sm:text-5xl md:text-6xl lg:text-9xl font-extrabold tracking-tight leading-tight text-white transition-all duration-1000 ease-out transform ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
          style={{ transitionDelay: '0.4s' }}
        >
          Syntari
        </h1>


        {/* STATUS */}
        <div 
          className={`mt-4 sm:mt-6 inline-flex items-center rounded-full border border-white/15 bg-white/5 px-4 sm:px-6 py-2 sm:py-3 text-base sm:text-lg text-white/90 backdrop-blur-sm transition-all duration-1000 ease-out transform ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
          style={{ transitionDelay: '0.6s' }}
        >
          Coming Soon.
        </div>

        {/* DESCRIPTION */}
        <p 
          className={`mt-6 sm:mt-8 text-base sm:text-lg md:text-xl text-white/70 max-w-3xl leading-relaxed transition-all duration-1000 ease-out transform ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
          style={{ transitionDelay: '0.8s' }}
        >
          We are defining a new standard: <span className="text-white font-semibold">Reality Engine</span>.
          Spin up lifelike data, personas, and worlds on demand. From patient records to financial
          transactions to entire simulated populations—Syntari makes it real enough to power AI,
          testing, and innovation while staying safe to share anywhere.
        </p>
      </div>

      {/* FOOTER */}
      <footer className="border-t border-white/10 bg-black/20 backdrop-blur-sm">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-8 sm:py-12">
          <div className="text-center">
            <div className="text-sm sm:text-base text-white/60">
              © Syntari 2025
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
